if (!customElements.get('news-blog')) {
  class NewsBlog extends HTMLElement {
    connectedCallback() {
      if (this.dataset.newsInitialized === 'true') return;
      this.dataset.newsInitialized = 'true';
    
      this.filters = this.querySelectorAll('[data-news-filter]');
      this.items   = this.querySelectorAll('[data-news-item]');
    
      this.onFilterClick = this.onFilterClick.bind(this);
      this.onHashChange  = this.onHashChange.bind(this);
    
      this.filters.forEach(filter => {
        filter.addEventListener('click', this.onFilterClick);
      });
    
      window.addEventListener('hashchange', this.onHashChange); 
    
      this.applyFilterFromHash(); 
    }
    

    applyFilterFromHash() {
      const hash = decodeURIComponent(window.location.hash.replace('#', ''));
      if (!hash) return;
    
      const matchedFilter = Array.from(this.filters).find(
        btn => btn.dataset.filter === hash
      );

      if (!matchedFilter) return;    
      matchedFilter.click();
    }
    

    disconnectedCallback() {
      this.filters.forEach(filter => {
        filter.removeEventListener('click', this.onFilterClick);
      });
    
      window.removeEventListener('hashchange', this.onHashChange);
      delete this.dataset.newsInitialized;
    }
    
    onHashChange() {
      this.applyFilterFromHash();
    }

    onFilterClick(event) {
      const filterBtn = event.currentTarget;
      const filter    = filterBtn.dataset.filter;
    
      this.filters.forEach(btn =>
        btn.classList.toggle('is-active', btn === filterBtn)
      );
    
      this.items.forEach(item => {
        const category = item.dataset.category;
    
        const shouldShow =
          filter === 'all' || category === filter;
    
        item.style.display = shouldShow ? '' : 'none';
      });
    
      if (filter === 'all') {
        history.replaceState(null, '', window.location.pathname);
      } else {
        history.replaceState(
          null,
          '',
          `#${encodeURIComponent(filter)}`
        );
      }
    }
    
  }

  customElements.define('news-blog', NewsBlog);
}
